import React, { Component } from 'react'
import { NavLink } from 'react-router-dom';
import './nav.css';

class Nav extends Component {
    state = {
        active: ''
    }
    handleBurgerClick (active) {
        // const navItems = document.querySelector('.nav-items li');
        if (active === '') {
            this.setState({ 
                active: 'nav-active'
            })
        } else {
            this.setState({ 
                active: ''
            })
        }

        // navItems && navItems.forEach((link, index) => {
        //     link.style.animation = `navItemFade 0.5 ease forwards ${index / 7 + 0.5}s`;
        // })
        
    }
    handleCloseNav (active) {
        if (active === '') {
            this.setState({ 
                active: 'nav-active'
            })
        } else {
            this.setState({ 
                active: ''
            })
        }
    }
    render () {
        const { active } = this.state
        return (
            <nav className={!this.props.scrolled ? 'nav' : 'nav scrolled'}>
                <div className={!this.props.scrolled ? 'scrolled-logo' : 'logo'}>
                    <NavLink to="/">
                        <h1>Redtomato</h1>
                    </NavLink>
                </div>
                <ul className={!this.props.scrolled ? `nav-items ${this.state.active}` : `scrolled-nav-items ${this.state.active}`}>
                    {/* <NavLink 
                        className='menu-item' 
                        to="/">
                        <li className='nav-logo'><h1>Redtomato</h1></li>
                    </NavLink> */}
                    <NavLink  
                        to="/"
                        onClick={() => this.handleCloseNav(active)}>
                        <li className=''>HOME</li>
                    </NavLink>
                    <NavLink
                        to="/work"
                        onClick={() => this.handleCloseNav(active)}>
                        <li>WORK</li>
                    </NavLink>
                    <NavLink
                        to="/about"
                        onClick={() => this.handleCloseNav(active)}>
                        <li>ABOUT</li>
                    </NavLink>
                    <NavLink
                        to="/contact"
                        onClick={() => this.handleCloseNav(active)}>
                        <li>CONTACT</li>
                    </NavLink>
                </ul>
                <div 
                    className='burger' 
                    onClick={() => this.handleBurgerClick(this.state.active)}>
                    <div className={!this.props.scrolled ? `line1` : `scrolled-line1`}></div>
                    <div className={!this.props.scrolled ? `line2` : `scrolled-line2`}></div>
                    <div className={!this.props.scrolled ? `line3` : `scrolled-line3`}></div>
                </div>
            </nav>
        )
    }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/base_layout/Header/Nav.js